import { createSelector } from '@reduxjs/toolkit';
import { NavigationSchema } from 'features/Navigation';
import { getNavigation } from '../getNavigation/getNavigation';

export const getNavigationActiveBurger = createSelector(
    getNavigation,
    (navigation: NavigationSchema) => navigation.activeBurger,
);
